import React, { useEffect, useState } from 'react'
import DetilnImg from '../pageStructure/DetilnImg';
import LowerLeft from './LowerLeft';
import LowerRight from './LowerRight';
import axios from 'axios';
import useGetFacultyImages from '../../hooks/useGetFacultyImages';


const facultyPage = {
  heading: 'Faculty of Geo-ICT',
  content: ['The faculty offers fundamental and progressive level of training in the domain of Cartography, Digital Mapping, and Geographic Information Systems.', 'The trainees are imparted with the core concepts in the theoretical sessions followed by the best-in-class live lab demonstrations.', ' Participants are provided In-depth instruction and a hands-on exercise using the latest software/s.The training programmes aim at inculcating and exposing the trainees with the industrial best practices and software/s thereby unleashing the full potential of the technological advancements.', 'Both online as well as offline courses are undertaken to cater to the wide variety of participants from Departmental, private and other governmental agencies.', 'The courses in GIS are designed to simulate the real world scenario and to provide solutions to the real world problems.', 'The faculty is equipped with well-trained faculty members with over all working experiences both in the conventional and modern technologies the spheres of Digital mapping and GIS.']
}
const FacultyGeo = () => {
  const [faculty, setFaculty] = useState(null);
  const [headData, setHeadData] = useState(null);
  
  const facultyImages = useGetFacultyImages('Faculty_Geo-ICT');

  const getFacultyMember = async () => {
    try {
      const url = "https://api.nigst.surveyofindia.gov.in/admin/faculty_member_faculty1/Faculty_Geo-ICT";
      const res = await axios.get(url);
      setFaculty(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getHeadFaculty = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/sadmin/view_admin`;
      const res = await axios.get(url);
      const headData = res.data.admins.find(item => item.faculty === 'Faculty_Geo-ICT');
      setHeadData(headData);
    } catch (error) {
      console.log(error)

    }
  }

  useEffect(() => {
    getFacultyMember();
    getHeadFaculty();
  }, [])

  return (
    <div className='m-2 md:m-4 p-2'>
      <DetilnImg heading={facultyPage.heading} text={facultyPage.content} images={facultyImages} />
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2  m-4 md:m-6 lg:m-8 rounded-md gap-2 md:gap-4 lg:gap-6'>
        <LowerLeft headData={headData} />
        <LowerRight data={faculty} />
      </div>
    </div>
  )
}

export default FacultyGeo